import { useEffect, useState } from "react";
import api from "@/lib/apiClient";
import { PageHeader, Loading, EmptyState } from "@/components/common";
import { Card } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { toast } from "sonner";
import { Search, Trash2, Hand } from "lucide-react";
import { fmtDate } from "@/lib/helpers";

export default function Interests() {
  const [rows, setRows] = useState(null);
  const [q, setQ] = useState("");
  const load = async () => { const { data } = await api.get("/interests"); setRows(data); };
  useEffect(() => { load(); }, []);

  const remove = async (id) => {
    await api.delete(`/interests/${id}`);
    toast.success("Removed");
    load();
  };

  if (!rows) return <Loading />;
  const s = q.toLowerCase();
  const visible = rows.filter((r) => [r.name, r.email, r.course_title].some((v) => (v || "").toLowerCase().includes(s)));

  return (
    <div className="space-y-6" data-testid="interests-page">
      <PageHeader title="Register Interest" subtitle={`${rows.length} people have registered interest in upcoming courses`} />
      <div className="relative max-w-md">
        <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground" />
        <Input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search by name, email or course…" className="pl-9" data-testid="interests-search-input" />
      </div>
      <Card className="overflow-hidden">
        {visible.length === 0 ? <EmptyState message="No registrations of interest yet." icon={Hand} /> : (
          <Table>
            <TableHeader><TableRow><TableHead>Name</TableHead><TableHead>Email</TableHead><TableHead>Course</TableHead><TableHead>Date</TableHead><TableHead /></TableRow></TableHeader>
            <TableBody>
              {visible.map((r) => (
                <TableRow key={r.id} data-testid={`interest-row-${r.id}`}>
                  <TableCell className="font-medium">{r.name}</TableCell>
                  <TableCell><a href={`mailto:${r.email}`} className="text-primary hover:underline">{r.email}</a></TableCell>
                  <TableCell>{r.course_title}</TableCell>
                  <TableCell>{fmtDate(r.created_at)}</TableCell>
                  <TableCell className="text-right">
                    <Button variant="ghost" size="icon" onClick={() => remove(r.id)} data-testid={`interest-delete-${r.id}`}><Trash2 className="h-4 w-4 text-red-500" /></Button>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        )}
      </Card>
    </div>
  );
}
